module.exports = __webpack_public_path__ + "img/xml.b5233e67.svg";